import api from './client'

export interface ChecklistDatabaseRow {
  file_id: string
  code: string
  is_published: boolean
  is_ai_submitted: boolean
  submitted_at: string | null
  fields: Record<string, unknown>
}

export interface ChecklistDatabaseResponse {
  total: number
  page: number
  page_size: number
  rows: ChecklistDatabaseRow[]
  column_labels: Record<string, string>
}

export const databaseApi = {
  list: (params: {
    page?: number
    page_size?: number
    search?: string
    published_only?: boolean
    source?: 'all' | 'human' | 'ai'
  }) => api.get<ChecklistDatabaseResponse>('/checklist-database', { params }).then((r) => r.data),
}
